"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUnlimitedRepetition = void 0;
function isUnlimitedRepetition(form, questionNodeId) {
    var _a;
    const question = form.questions[questionNodeId];
    if (question === null || question === void 0 ? void 0 : question.repetitionAncestorId) {
        const repNode = form.questions[question.repetitionAncestorId];
        const repRule = form.rules[repNode.questionId];
        if ((_a = repRule === null || repRule === void 0 ? void 0 : repRule.unLimitedTimes) === null || _a === void 0 ? void 0 : _a.enabled)
            return true;
    }
    return false;
}
exports.isUnlimitedRepetition = isUnlimitedRepetition;
exports.default = isUnlimitedRepetition;
